'use client';

import { useState } from 'react';

import { ArrowDown } from '@/components/atoms/Icons';

export default function NewsToc({ headings = [], SelectId = '' }) {
  const [selected, setSelected] = useState('');
  const [showAll, setShowAll] = useState(false);

  if (!headings.length) return null;

  const MAX_ITEMS = 5;
  const visibleHeadings = showAll ? headings : headings.slice(0, MAX_ITEMS);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelected(value);
    if (!value) return;
    const el = document.getElementById(value);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.history.replaceState(null, '', `#${value}`);
  };

  return (
    <div>
      <div className="hidden lg:block">
        <p className="text-[12px] leading-[22px] font-medium font-outfit text-[#757575]">
          Contents
        </p>
        <ul className="mt-2.25">
          {visibleHeadings.map((heading) => (
            <li key={heading.id} className="py-2.5 border-b border-[#DCDCDC] last:border-b-0">
              <a
                href={`#${heading.id}`}
                className="block  text-lg font-semibold text-[#323232] leading-[1.35em]"
              >
                {heading.text}
              </a>
            </li>
          ))}
        </ul>

        {headings.length > MAX_ITEMS && !showAll && (
          <button
            onClick={() => setShowAll(true)}
            className="mt-2 text-sm font-semibold text-[#323232] cursor-pointer"
          >
            …more
          </button>
        )}
      </div>

      <div className="lg:hidden md:max-w-[80%]">
        <label
          className="text-[13px] leading-[22px] font-semibold text-[#323232]"
          htmlFor={SelectId}
        >
          Jump to section
        </label>
        <div className="relative">
          <select
            id={SelectId}
            className="mt-1 w-full rounded-lg appearance-none border border-[#DDDDDD] bg-white pl-3 pr-10 py-2 h-11 text-base font-reguler text-[#757575]"
            value={selected}
            onChange={handleChange}
          >
            {headings.map((heading) => (
              <option key={heading.id} value={heading.id}>
                {heading.text}
              </option>
            ))}
          </select>
          <ArrowDown className="pointer-events-none absolute inset-y-0 right-4 m-auto" />
        </div>
      </div>
    </div>
  );
}
